<template>
  <ll-new-modal
    :class="bem.b()"
    title="上传文件"
    :open="visible"
    :keyboard="false"
    :mask-closable="false"
    :width="'900px'"
    @cancel="handleClickCancelBtn"
    @ok="handleClickOkBtn"
  >
    <div :class="bem.e('content')">
      <a-upload-dragger
        v-bind="attrs"
        :accept="props.accept"
        :multiple="props.multiple"
        :file-size="props.fileSize"
        :before-upload="beforeUpload"
        :custom-request="customRequest"
        :file-list="fileList"
        @reject="handleDragReject"
        @remove="handleRemove"
      >
        <template #iconRender>
          <ll-icon icon-name="icon-add" />
        </template>
        <template #removeIcon>
          <ll-icon icon-name="icon-delete" />
        </template>
        <p class="ant-upload-drag-icon">
          <ll-icon icon-name="icon-add" color="#1890ff" />
        </p>
        <p class="ant-upload-text">
          将文件拖到此处，或
          <a>点击上传</a>
        </p>
        <p class="ant-upload-hint">
          {{
            props.tip
              ? props.tip
              : '支持单个或多个上传，严禁上传公司数据或其他被禁止的文件！'
          }}
        </p>
      </a-upload-dragger>
    </div>
  </ll-new-modal>
  <ll-button
    v-if="!$slots.buttonContent"
    :disabled="props.disabled"
    @click="visible = true"
  >
    <template #icon>
      <ll-icon icon-name="icon-upload" />
    </template>
    上传文件
  </ll-button>
  <ll-button
    v-else
    type="link"
    class="button-content-btn"
    :disabled="props.disabled"
    @click="visible = true"
  >
    <slot name="buttonContent" />
  </ll-button>
</template>

<script lang="ts" setup>
// import * as fileApi from '@/api/file'

import type { UploadProps } from 'ant-design-vue'
import { message } from 'ant-design-vue'
import { ref, useAttrs, watch, watchEffect } from 'vue'
import { ILlUploadDragProps } from './upload-drag'

import { createNamespace } from '@ll-plus/utils'

defineOptions({ name: 'LlUploadDrag' })

const attrs = useAttrs()

const bem = createNamespace('upload-drag')

const props = defineProps(ILlUploadDragProps)
const emits = defineEmits([
  'update:value',
  'customRequest',
  'cancel',
  'confirm',
])

const visible = ref(false)
const originalFileList = ref<any[]>([])

const fileList = ref<any[]>([])

// 校验文件类型是否满足
const checkFileType = (file: any) => {
  if (!props.accept) return true

  // 获取文件扩展名
  const extension = file.name.split('.').pop()?.toLowerCase() || ''

  // 获取允许的扩展名列表
  const allowedExtensions = props.accept
    .split(',')
    .map((ext) => ext.trim().replace('.', '').toLowerCase())

  // 检查扩展名是否在允许的列表中
  const isValid = allowedExtensions.includes(extension)

  if (!isValid) {
    const allowedFormats = allowedExtensions.join('/')
    message.error(`${file.name} 需要为 ${allowedFormats} 格式`)
    return false
  }

  return true
}

// 校验文件大小是否满足
const checkFileSize = (file: any) => {
  const isSize = !props.fileSize ? true : file.size <= props.fileSize
  if (!isSize) {
    message.error(`${file.name} 文件过大`)
    return false
  }
  return true
}

// 上传前触发钩子函数
const beforeUpload: UploadProps['beforeUpload'] = async (file) => {
  return checkFileType(file) && checkFileSize(file)
}

// 自定义上传函数
const customRequest: UploadProps['customRequest'] = async (res: any) => {
  console.log(res)
  fileList.value.push(res.file)
  emits('customRequest', res)
}

// 移除
const handleRemove = async (e: any) => {
  fileList.value = fileList.value.filter((item) => item.uid !== e.uid)
}

// 拖拽不符合accept的
const handleDragReject = () => {
  message.error('请上传正确的文件格式')
}
const handleClickCancelBtn = () => {
  fileList.value = originalFileList.value
  emits('update:value', originalFileList.value)
  emits('cancel')
  visible.value = false
}
const handleClickOkBtn = () => {
  emits('update:value', fileList.value)
  emits('confirm')
  visible.value = false
}

watchEffect(() => {
  if (visible.value) {
    originalFileList.value = [...props.value] // 使用浅拷贝代替深拷贝
  }
})

watch(
  () => props.value,
  (arr) => {
    fileList.value = arr
  }
)
</script>
